import Konva from "konva";
import Helper from "../Helper";
export default class _Image extends Konva.Image{
    constructor(attributes){
        super(attributes);
        this.className = 'myimage';
        this.imageObject = undefined;
        this.maskObject = undefined;
        this.textureObject = undefined;
        this.imageLoaded = false;
        this.textureLoaded = false;
        this.maskLoaded = false;
    }

    _sceneFunc(ctx){
        if(this.imageObject && this.imageLoaded){
            ctx.save();
            ctx.shadowColor="transparent";

            if(this.maskLoaded && this.maskObject){
                ctx.drawImage(this.maskObject, 0, 0, this.attrs.width, this.attrs.height);      
                ctx.globalCompositeOperation = 'source-in';
            }

            let zoom = this.getAttr('zoom');
            let offset_x = parseInt(this.getAttr('offset_x'));
            let offset_y=parseInt(this.getAttr('offset_y'));

            if(!zoom) zoom=1;
            if(!offset_x) offset_x=0;
            if(!offset_y) offset_y=0;
                    
            let image_width = this.imageObject.naturalWidth;
            let image_height = this.imageObject.naturalHeight;      
            let frame_width = Number(this.getAttr('width'));
            let frame_height= Number(this.getAttr('height'));;
            let image_ratio = image_width/image_height;
            let frame_ratio = frame_width/frame_height;
            let source_x=0;
            let source_y=0; 
            let source_width=image_width;
            let source_height=image_height;
            let diff=0;

            if(image_ratio < frame_ratio) {
                source_width = image_width
                let virtual_height=frame_width/image_ratio;
                diff = virtual_height-frame_height;
                diff = diff*(image_width/frame_width);
                source_height = source_height - diff
                source_x = 0;
                source_y = diff/2;
            }
            // If image's aspect ratio is greater than frame's we fit on width
            else if(image_ratio > frame_ratio) {              
                source_height = image_height
                let virtual_width=frame_height*image_ratio;
                diff = virtual_width-frame_width;
                diff = diff*(image_height/frame_height);
                source_width = source_width - diff
                source_x = diff/2;
                source_y = 0;
            }else{
                source_height = image_width;
                source_width = image_height;
                source_x = 0;
                source_y = 0;
            }
            
            // ZOOM
            let diff_width=(source_width - source_width/zoom)/2;
            let diff_height=(source_height - source_height/zoom)/2;
            
            source_width = source_width / zoom;
            source_height = source_height / zoom;
            source_x=source_x+diff_width;
            source_y=source_y+diff_height;

            source_x = source_x - offset_x * ((image_width-source_width)/200);
            source_y = source_y - offset_y * ((image_height-source_height)/200);
            //source_height = source_height -offset_y

            if(source_x < 0) {source_x = 0; }
            if(source_y < 0) {source_y = 0; }

            if(source_x + source_width > image_width) source_x = image_width-source_width;
            if(source_y + source_height > image_height) source_y = image_height-source_height;

            ctx.drawImage(this.imageObject, source_x, source_y, source_width, source_height, 0, 0, frame_width, frame_height);
            ctx.restore();

            if(this.textureObject && this.textureLoaded){
                ctx.save();
                ctx.globalCompositeOperation = 'source-in';
                let group_pos = this.getParent().position();
                let frame_pos = this.position();
                let sumarryRotation = (this.rotation() * -1 )* Math.PI / 180;
                let x = (group_pos.x+frame_pos.x)*-1;
                let y = (group_pos.y+frame_pos.y)*-1;

                if(this.getAttr('rotate_texture')){
                    if(this.getAttr('rotate_texture') == 270)
                    {
                        sumarryRotation = (this.getAttr('rotate_texture'))* Math.PI / 180;
                        let z;
                        z = x;
                        x = y-1000 + ((group_pos.y+frame_pos.y)*2);
                        y = z;
                    }
                    if(this.getAttr('rotate_texture') == 90)
                    {
                        sumarryRotation = (this.getAttr('rotate_texture'))* Math.PI / 180;
                        let z;
                        z = x-1000 + ((group_pos.x+frame_pos.x)*2);
                        x = y;
                        y = z;
                    }
                }

                ctx.rotate(sumarryRotation);
                ctx.drawImage(this.textureObject, 0, 0, 1000, 1000, x, y, 1000, 1000);  
                ctx.restore();
            }
        }
    }

    setImageObject(img){
        this.imageObject = img;
        this.imageLoaded = true;
    }

    load(_resolve, reject){
        let promises = [];
        if(this.getAttr('mask_src')){
            promises.push(
                new Promise((resolve, reject) => {
                    this.loadMask(
                        this.getAttr('mask_src'), resolve, reject
                    )
                })

                
            );

            promises.push(
                new Promise((resolve, reject)=>{
                    this.loadImage(
                        this.getAttr('image_src'),
                        resolve, reject
                    )
                })
            );
        }else if(this.getAttr('image_src')){
            promises.push(
                new Promise((resolve, reject) => {
                    this.loadImage(
                        this.getAttr('image_src'),
                        resolve, reject
                    )
                })
            );
        }

        if(this.getAttr('texture_src')){
            promises.push(
                new Promise((resolve, reject) => {
                    this.loadTexture(this.getAttr('texture_src'),
                        resolve, reject
                    );
                })
            )
        }

        Promise.all(promises)
        .then(value => {
            _resolve("OK");
        })
        .catch(err => {
            _resolve(err);
        });
    }

    loadMask(maskSrc, resolve, reject){
        this.maskObject = Helper.loadImage(
            maskSrc, 
            ()=>{
                this.maskLoaded = true;
                resolve();
            },
            err => {
                resolve(err);
            }
        );
    }

    loadTexture(maskSrc, resolve, reject){
        this.textureObject = Helper.loadImage(
            maskSrc, 
            ()=>{
                this.textureLoaded = true;
                resolve();
            },
            err => {
                resolve(err);
            }
        );
    }

    loadImage(imageSrc, resolve, reject){
        this.imageObject = Helper.loadImage(
            imageSrc, 
            ()=>{
                this.imageLoaded = true;
                resolve();
            },
            err => {
                reject(err);
            });
    }
}

Konva.myimage = _Image;